<template>
  <v-expansion-panel v-bind="$attrs" class="panel" v-model="open">
    <v-expansion-panel-header color="element">
      {{ header }}
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      {{ content && content }}
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "p-expansion-panel",

  data: () => {
    return {
      open: null,
    };
  },

  props: ["header", "content", "value"],

  watch: {
    value: {
      handler() {
        if (this.value) this.open = this.value;
      },
    },
  },
};
</script>

<style>
@import "./styles.css";
</style>
